import React from "react";
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import Table from "examples/Tables/Table";
import { Card, CircularProgress } from "@mui/material";
import SchoolIcon from "@mui/icons-material/School";

// Argon Dashboard 2 MUI examples
import Footer from "examples/Footer";

import { useState, useEffect } from "react";

import TutoProfileCard from "./TutoProfileCard";
import DemoAllocatetTableData from "Views/people/tutor/tutorProfileTabs/data/DemoAllocated";
import { useParams } from "react-router-dom";

function BasicDetails() {
  const { id } = useParams();
  const { columns, rows, loading } = DemoAllocatetTableData(id);

  if (loading) {
    return (
      <ArgonBox>
        <Card sx={{ p: 5 }}>
          <ArgonBox
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            gap={2}
          >
            <CircularProgress />
            <ArgonTypography variant="h6" color="text">
              Loading Demo and Class Data...
            </ArgonTypography>
          </ArgonBox>
        </Card>
      </ArgonBox>
    );
  }

  if (rows.length === 0) {
    return (
      <ArgonBox>
        <Card sx={{ p: 5 }}>
          <ArgonBox
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            gap={2}
          >
            <SchoolIcon sx={{ fontSize: 64, color: "#d0d0d0" }} />
            <ArgonTypography variant="h6" color="text">
              No Demo or Class Data Available
            </ArgonTypography>
            <ArgonTypography variant="caption" color="text" textAlign="center">
              This tutor hasn&apos;t been allocated any demos or classes yet.
            </ArgonTypography>
          </ArgonBox>
        </Card>
      </ArgonBox>
    );
  }

  return (
    <ArgonBox>
      {/* <TutoProfileCard/> */}
      <ArgonBox
        mt={5}
        sx={{
          "& .MuiTableRow-root:not(:last-child)": {
            "& td": {
              borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                `${borderWidth[1]} solid ${borderColor}`,
            },
          },
        }}
      >
        <Table columns={columns} rows={rows} />
      </ArgonBox>
    </ArgonBox>
  );
}

export default BasicDetails;
